<template>
  <md-card id="report_toolbar">
    <div class="md-layout" v-if="this.$allowed('reports.manage')">
      <md-button
        v-if="this.$allowed('reports.manage')"
        class="md-primary md-sm download-button"
        @click.prevent="tourshirt"
        ><md-icon>description</md-icon> Tour Shirts</md-button
      >
      <md-button
        v-if="this.$allowed('reports.manage')"
        class="md-primary md-sm download-button"
        @click.prevent="bikehire"
        ><md-icon>description</md-icon> Bike Hire</md-button
      >
      <md-button
        v-if="this.$allowed('reports.manage')"
        class="md-primary md-sm download-button"
        @click.prevent="showDateDialog = true"
        ><md-icon>description</md-icon> Global Rescue</md-button
      >
    </div>

    <md-dialog :md-active.sync="showDateDialog">
      <md-dialog-title>Pick your Date Range</md-dialog-title>

      <div class="md-layout" style="padding: 15px">
        <div class="md-layout-item md-size-100">
          <date-picker
            v-model="dateRange"
            value-type="format"
            format="YYYY-MM-DD"
            range
          ></date-picker>
        </div>
      </div>

      <md-dialog-actions>
        <md-button class="md-primary md-dense" @click="showDateDialog = false"
          >Cancel</md-button
        >
        <md-button class="md-primary md-dense" @click="globalrescue"
          >OK</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import reportApi from "@/services/api/report";
import moment from "moment";
import "vue2-datepicker/index.css";

export default {
  name: "ReportDashboard",

  data() {
    return {
      showDateDialog: false,
      dateRange: [null, null]
    };
  },

  mounted() {
    this.dateRange = [
      moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      moment()
        .endOf("month")
        .format("YYYY-MM-DD")
    ];
  },

  methods: {
    tourshirt() {
      reportApi.tourshirt().then(response => {
        let fileName = `tourshirts_${moment().format("YYMMDD")}.csv`;
        this.download(response, fileName);
      });
    },

    bikehire() {
      reportApi.bikehire().then(response => {
        let fileName = `bikehire_${moment().format("YYMMDD")}.csv`;
        this.download(response, fileName);
      });
    },

    globalrescue() {
      this.showDateDialog = false;

      let params = {
        startDate: this.dateRange[0],
        endDate: this.dateRange[1]
      };

      reportApi.globalrescue(params).then(response => {
        let fileName = `globalrescue_${moment().format("YYMMDD")}.csv`;
        this.download(response, fileName);
      });
    },

    download(fileData, fileName) {
      let fileURL = window.URL.createObjectURL(new Blob([fileData]));
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
      document.body.removeChild(fileLink);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
#report_toolbar {
  .md-layout {
    padding: 10px;
    justify-content: flex-end;
  }

  .download-button {
    margin: 3px;
  }
}
</style>
